import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import imgNotFound from '~/assets/images/404.gif';
import { modifyTitle } from '~/store/modules/drawer/actions';

import { Container, Image, Content } from './style';

export default function NotFound() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(modifyTitle(''));
  }, [dispatch]);

  return (
    <Container>
      <Image>
        <img src={imgNotFound} alt="not found" />
      </Image>

      <Content>
        <h1>Oops!</h1>
        <h5>Nao conseguimos encontrar a página que você estava procurando.</h5>
      </Content>
    </Container>
  );
}
